<template>
  <section class="rider-story-block py-5">
    <CContainer>
      <CRow>
        <CCol md="4">
          <div class="rider-thumb">
            <img src="/img/avatars/thumb-1.jpg" alt="" />
          </div>
        </CCol>
        <CCol md="8">
          <div class="rider-detail">
            <h4>Shreyash Poudel</h4>
            <p>Professin if available</p>
          </div>
          <div class="rich-text">
            <p>
              <i>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor. Aenean massa. Cum sociis natoque
                penatibus.
              </i>
            </p>
            <br />
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa. Cum sociis natoque
              penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Donec quam felis, ultricies nec,
            </p>
            <p>
              pellentesque eu, pretium quis, sem. Nulla consequat massa quis
              enim. Donec pede justo, fringilla vel, aliquet nec, vulputate
              eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis
              vitae, justo. Nullam dictum felis eu pede
            </p>
            <br /><br />

            <blockquote>
              consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
              Aenean massa. Cum sociis natoque penatibus et magnis dis
              parturient montes, nascetur ridiculus mus. Donec quam felis,
              ultricies nec, Aenean massa. Cum sociis natoque penatibus et
              magnis dis parturient montes, nascetur ridiculus mus. Donec quam
              felis, ultricies nec,
            </blockquote>
            <br /><br />
            <h4>pellentesque eu, pretium quis, sem</h4>
            <ul>
              <li>
                Nulla consequat massa quis enim. Donec pede justo, fringilla vel
              </li>
              <li>Aenean massa. Cum sociis natoque</li>
              <li>Nullam dictum felis eu pede</li>
            </ul>
            <br />
            <h4>pellentesque eu, pretium quis, sem</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa. Cum sociis natoque
              penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Donec quam felis, ultricies nec,
            </p>
            <p>
              pellentesque eu, pretium quis, sem. Nulla consequat massa quis
              enim. Donec pede justo, fringilla vel, aliquet nec, vulputate
              eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis
              vitae, justo. Nullam dictum felis eu pede
            </p>
            <br />
            <h4>pellentesque eu, pretium quis, sem</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa. Cum sociis natoque
              penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Donec quam felis, ultricies nec,
            </p>
            <p>
              pellentesque eu, pretium quis, sem. Nulla consequat massa quis
              enim. Donec pede justo, fringilla vel, aliquet nec, vulputate
              eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis
              vitae, justo. Nullam dictum felis eu pede
            </p>
          </div>
          <div class="covered-by mt-5">
            <h4>Covered By: Shreyash Poudel</h4>
            <p>Professin if available</p>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </section>
</template>

<script>
export default {
  name: "RiderStoryBlock",
};
</script>

<style lang="scss" scoped></style>
